var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetorno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1228",
    "data-name": "Grupo 1228",
    transform: "translate(-87 7703)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_895",
    className: "circleIconState",
    "data-name": "Caminho 895",
    d: "M20.5,0A20.5,20.5,0,1,1,0,20.5,20.5,20.5,0,0,1,20.5,0Z",
    transform: "translate(87 -7703)",
    fill: "#e64a19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_896",
    "data-name": "Caminho 896",
    d: "M558.728,185.966a12.367,12.367,0,0,0-11.319,7.414h4.226a8.671,8.671,0,1,1-.568,8.9l3.955-3.955h-9.886v9.886L548.348,205a12.35,12.35,0,1,0,10.38-19.03Z",
    transform: "translate(-451.135 -7880.966)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetorno);
export default __webpack_public_path__ + "static/media/Retorno.5e79a902b4d555345204de8b1cc37e17.svg";
export { ForwardRef as ReactComponent };